const NEWS_DATE_TIME_FORMATTER = new Intl.DateTimeFormat("en-US", {
	timeZone: "Asia/Shanghai",
	year: "numeric",
	month: "short",
	day: "numeric",
	hour: "2-digit",
	minute: "2-digit",
	hourCycle: "h23",
})

/** 新闻时间固定格式：Jul 3, 2025 14:31 */
export function formatNewsDateTime(pubDateSeconds: string | number): string {
	const seconds = Number(pubDateSeconds)
	if (!Number.isFinite(seconds) || seconds <= 0) return ""

	const parts = NEWS_DATE_TIME_FORMATTER.formatToParts(new Date(seconds * 1000))
	const getPart = (type: Intl.DateTimeFormatPartTypes) => parts.find((part) => part.type === type)?.value ?? ""

	return `${getPart("month")} ${getPart("day")}, ${getPart("year")} ${getPart("hour")}:${getPart("minute")}`
}

/**
 * 新闻发布时间展示规则：
 * - 1 小时内：X min(s) ago
 * - 24 小时内：X hour(s) ago
 * - 否则：Oct 19, 2025 14:32
 */
export function formatNewsPubTime(pubDateSeconds: number, nowSeconds: number = Date.now()): string {
	const diff = nowSeconds - pubDateSeconds
	if (diff < 0) return formatFallback(pubDateSeconds)
	if (diff < 3600) {
		const mins = Math.floor(diff / 60)
		return mins <= 1 ? "1 min ago" : `${mins} mins ago`
	}
	if (diff < 86400) {
		const hours = Math.floor(diff / 3600)
		return hours <= 1 ? "1 hour ago" : `${hours} hours ago`
	}
	return formatFallback(pubDateSeconds)
}

/** 仅用发布时间格式化，不依赖当前时间，用于首屏/SSR 避免与客户端 Date.now() 不一致导致 hydration 报错 */
export function formatNewsPubTimeStable(pubDateMs: number): string {
	const d = new Date(pubDateMs)
	const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	const month = months[d.getMonth()]
	const day = d.getDate()
	const year = d.getFullYear()
	// const h = d.getHours()
	// const m = d.getMinutes()
	// const pad = (n: number) => String(n).padStart(2, "0")
	// return `${month} ${day}, ${year} ${pad(h)}:${pad(m)}`
	return `${month} ${day}, ${year}`
}

function formatFallback(seconds: number): string {
	return formatNewsPubTimeStable(seconds)
}
